import locale from "localization";

export const payWithLOCQPayColumns = [
  {
    key: "paymentId",
    text: locale.locqPayId,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "businessNameId",
    text: locale.businessNameId,
    style: {
      minWidth: "100px",
    },
  },
  {
    key: "paymentStationAndStationBusinessName",
    text: `${locale.gasUpStationWithOutDash}/${locale.stationBusinessName}`,
    style: {
      minWidth: "250px",
    },
  },
  {
    key: "cardNumber",
    text: locale.fleetCardNo,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "driversNameandId",
    text: `${locale.driversName}/${locale.driversId}`,
    style: {
      minWidth: "250px",
    },
  },
  {
    key: "plateNumber",
    text: locale.plateNumber,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "product",
    text: locale.product,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "volume",
    text: locale.volume,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "paidAt",
    text: `${locale.dateOfTransaction}`,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "amount",
    text: locale.paymentAmount,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "pumpPrice",
    text: `${locale.pumpPrice} (P/L)`,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "discount",
    text: `${locale.discount}`,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "discountedVolume",
    text: `${locale.discountPerLiter} (P/L)`,
    style: {
      minWidth: "70px",
    },
  },
  {
    key: "finalAmount",
    text: locale.finalAmountPaid,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "poNumber",
    text: locale.poNumber,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "orNumber",
    text: locale.orNumber,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "status",
    text: locale.status,
    style: {
      minWidth: "200px",
    },
  },
  {
    key: "remarks",
    text: locale.remarks,
    style: {
      minWidth: "150px",
    },
  },
  {
    key: "settlementStatus",
    text: `${locale.settlementStatus}/${locale.settlementId}`,
    style: {
      width: "500px",
    },
  },
  {
    key: "options",
    text: `${locale.action}`,
    style: {
      width: "300px",
    },
  },
];
